import { types, actions } from './requests'
export const GETLOTLIST_TYPES = {
    ...types('GETLOTLIST'),
}
export const GETLOTLIST_ACTIONS = {
    ...actions('GETLOTLIST'),
}